import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { UserStorage } from './../../../../helper';

import { TeamSummaryService } from '../team-summary.service';
import { UserDetailService } from '../user-detail';

import { UserEditService } from './user-edit.service';

import { Roles } from './../../../../model';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  userId = '';
  user: any;
  teams: any[];
  roles = Roles;

  redirect = true;

  editUserForm: FormGroup;
    email: string = "";
    firstName: string = "";
    lastName: string = "";
    teamId = "";
    role = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private teamSummaryService: TeamSummaryService,
    private userEditService: UserEditService,
    private userDetailService: UserDetailService,
    private formBuilder: FormBuilder,
    private currentUser: UserStorage
    ) {
    this.route.params.subscribe(params => { this.userId = params['id']; });
    translateService.setDefaultLang('en-us');
}

createEditUserForm() {
        this.editUserForm = this.formBuilder.group({
            email: new FormControl({value: '', disabled: true }, [
                Validators.required,
                Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
                Validators.maxLength(100)
            ]),
            firstName: new FormControl('', [
                Validators.required,
                Validators.maxLength(100)

            ]),
            lastName: new FormControl('', [
                Validators.required,
                Validators.maxLength(100)

            ]),
            teamId: new FormControl('', [
                Validators.required

            ]),
            role: new FormControl('', [
                Validators.required

            ])
        });
}

editUser(editUserForm) {

        this.userEditService.edit(this.userId, editUserForm.controls).subscribe(
            data  => {
                if (data) {
                  if (this.currentUser.getLocalUserID() === this.userId) {
                    this.currentUser.saveLocalUser(data);
                  }

                  this.dialog.showModal('showSucModalBtn');

                }
            },
            error => {
              this.exception.showError(error, 'showDanModalBtn');
              this.redirect = false;
            }
        );

    }

  ngOnInit() {
    this.createEditUserForm();

    this.userDetailService.getDetail(this.userId).subscribe( (data) => {

                this.user = data;

                this.teamSummaryService.getSummary().subscribe((data: any) => {

                  this.teams = data;

                  this.editUserForm.setValue({
                    email: this.user.email ,
                    firstName: this.user.firstName ,
                    lastName: this.user.lastName ,
                    teamId: this.user.teamId ,
                    role: this.user.role
                    });

                },
                error => {
                  $('.card').hide();
                  this.exception.showError(error, 'showDanModalBtn');
                  this.redirect = true;
                });

            },
            error => {
              $('.card').hide();
              this.exception.showError(error, 'showDanModalBtn');
              this.redirect = true;
            }
        );

  }

  closeSuccessModel() {
    this.router.navigate(['/home/users/detail/' + this.userId]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/users']);
    }
    else {
      this.dangerModal.hide();
    }

  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-edit/user-edit.component.ts